"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const types_1 = require("@src/types");
const account_context_1 = require("@src/context/account-context");
const InviteUserModal_1 = require("./InviteUserModal");
const InvitationPendingText = styled_components_1.default.span `
	color: ${({ theme }) => theme.color.gray5};
`;
const SuccessButton = (0, styled_components_1.default)(elements_1.Button) `
	color: ${({ theme }) => theme.color.success};
`;
function AdminUsers() {
    const [accounts, setAccounts] = react_1.default.useState(null);
    const [acceptationPendingAccounts, setAcceptationPendingAccounts] = react_1.default.useState(null);
    const [isInvitationModalOpen, setIsInvitationModalOpen] = react_1.default.useState(false);
    const [invitationIdBeingRemoved, setInvitationIdBeingRemoved] = react_1.default.useState(null);
    const [acceptationIdLoading, setAcceptationIdLoading] = react_1.default.useState(null);
    const account = (0, account_context_1.useAccount)();
    const isVerified = Boolean(account === null || account === void 0 ? void 0 : account.verified);
    const intl = (0, react_intl_1.useIntl)();
    const init = react_1.default.useCallback(async () => {
        try {
            const companyAccounts = await Api.Admin.getCompanyAccounts();
            setAcceptationPendingAccounts(companyAccounts
                .filter(a => { var _a; return ((_a = a.companyAccountRole) === null || _a === void 0 ? void 0 : _a.role) === types_1.CompanyAccountRole.acceptation_pending; })
                .map(a => ({ ...a, key: `company-account-${a.id}` })));
            setAccounts(companyAccounts
                .filter(a => { var _a; return ((_a = a.companyAccountRole) === null || _a === void 0 ? void 0 : _a.role) !== types_1.CompanyAccountRole.acceptation_pending; })
                .map(a => ({ ...a, key: `company-account-${a.id}` })));
        }
        catch (err) {
            console.error(err);
        }
    }, []);
    const removeInvitation = react_1.default.useCallback(async (invitationId) => {
        try {
            setInvitationIdBeingRemoved(invitationId);
            await Api.Admin.removeInvitation(invitationId);
            setAccounts(accounts.filter(a => a.id !== invitationId));
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setInvitationIdBeingRemoved(null);
        }
    }, [accounts]);
    const approveAcceptation = react_1.default.useCallback(async (userId) => {
        try {
            setAcceptationIdLoading(userId);
            await Api.Admin.changeUserRole(userId, types_1.CompanyAccountRole.admin);
            await init();
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'admin.users.acceptation.approved_successfully',
                }),
                description: '',
            });
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setAcceptationIdLoading(null);
        }
    }, [acceptationPendingAccounts]);
    const declineAcceptation = react_1.default.useCallback(async (userId) => {
        try {
            setAcceptationIdLoading(userId);
            await Api.Admin.deleteUser(userId);
            await init();
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setAcceptationIdLoading(null);
        }
    }, [acceptationPendingAccounts]);
    react_1.default.useEffect(() => {
        init();
    }, []);
    const accountColumns = [
        {
            title: intl.formatMessage({
                id: 'admin.users.name',
            }),
            key: 'full_name',
            render: (_, acc) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!acc.first_name && ((0, jsx_runtime_1.jsxs)(InvitationPendingText, { children: ["(", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.users.invitation_pending" }), ")"] })), Boolean(acc === null || acc === void 0 ? void 0 : acc.first_name) && ((0, jsx_runtime_1.jsxs)("span", { children: [acc === null || acc === void 0 ? void 0 : acc.first_name, " ", acc === null || acc === void 0 ? void 0 : acc.last_name] }))] })),
        },
        {
            title: intl.formatMessage({
                id: 'admin.users.email',
            }),
            dataIndex: 'email',
            key: 'email',
        },
        {
            width: 50,
            key: 'actions',
            render: (_, acc) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !acc.first_name && ((0, jsx_runtime_1.jsx)(antd_1.Popconfirm, { placement: "topLeft", title: intl.formatMessage({ id: 'admin.users.invitation_are_you_sure' }), onConfirm: () => removeInvitation(acc.id), okText: intl.formatMessage({ id: 'general.yes' }), okButtonProps: { loading: invitationIdBeingRemoved === acc.id }, cancelText: intl.formatMessage({ id: 'general.no' }), children: (0, jsx_runtime_1.jsxs)(elements_1.Button, { danger: true, type: "text", size: "small", children: [(0, jsx_runtime_1.jsx)(icons_1.DeleteOutlined, { className: "m-r-s" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.users.invitation_delete" })] }) })) })),
        },
    ];
    const acceptationPendingAccountColumns = [
        {
            title: intl.formatMessage({
                id: 'admin.users.name',
            }),
            key: 'full_name',
            render: (_, acc) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("span", { children: [acc.first_name, " ", acc.last_name] }) })),
        },
        {
            title: intl.formatMessage({
                id: 'admin.users.email',
            }),
            dataIndex: 'email',
            key: 'email',
        },
        {
            width: 50,
            key: 'actions',
            render: (_, acc) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-row justify-space-between", children: [(0, jsx_runtime_1.jsxs)(SuccessButton, { onClick: () => approveAcceptation(acc.id), type: "text", size: "small", children: [(0, jsx_runtime_1.jsx)(icons_1.CheckOutlined, { className: "m-r-s" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.accept" })] }), (0, jsx_runtime_1.jsx)(antd_1.Popconfirm, { placement: "topLeft", title: intl.formatMessage({ id: 'admin.users.acceptation.are_you_sure' }), onConfirm: () => declineAcceptation(acc.id), okText: intl.formatMessage({ id: 'general.yes' }), okButtonProps: { loading: acceptationIdLoading === acc.id }, cancelText: intl.formatMessage({ id: 'general.no' }), children: (0, jsx_runtime_1.jsxs)(elements_1.Button, { danger: true, type: "text", size: "small", children: [(0, jsx_runtime_1.jsx)(icons_1.CloseOutlined, { className: "m-r-s" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.decline" })] }) })] }) })),
        },
    ];
    const showAcceptationTable = Boolean(acceptationPendingAccounts) && (acceptationPendingAccounts === null || acceptationPendingAccounts === void 0 ? void 0 : acceptationPendingAccounts.length) > 0;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(elements_1.Panel, { className: "p-m", children: (0, jsx_runtime_1.jsxs)(antd_1.Collapse, { expandIconPosition: "right", className: "font-size-m", defaultActiveKey: ['1', '2'], children: [showAcceptationTable && ((0, jsx_runtime_1.jsx)(antd_1.Collapse.Panel, { header: (0, jsx_runtime_1.jsx)("span", { className: "font-size-l", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.users.awaiting_approval" }) }), children: (0, jsx_runtime_1.jsx)(elements_1.Table, { pagination: false, dataSource: acceptationPendingAccounts, columns: acceptationPendingAccountColumns, scroll: { x: 'max-content' } }) }, "1")), (0, jsx_runtime_1.jsxs)(antd_1.Collapse.Panel, { header: (0, jsx_runtime_1.jsx)("span", { className: "font-size-l", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.users.company_users" }) }), children: [!accounts && (0, jsx_runtime_1.jsx)(antd_1.Skeleton, { active: true }), Boolean(accounts) && ((0, jsx_runtime_1.jsx)(elements_1.Table, { pagination: false, dataSource: accounts, columns: accountColumns, scroll: { x: 'max-content' } })), Boolean(isVerified) && ((0, jsx_runtime_1.jsx)("div", { className: "flex-center m-t-l", children: (0, jsx_runtime_1.jsxs)(elements_1.Button, { className: "flex-row align-center", shape: "round", size: "middle", type: "primary", onClick: () => setIsInvitationModalOpen(true), children: [(0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, { className: "m-r-s" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.users.invite_users" })] }) }))] }, "2")] }) }), (0, jsx_runtime_1.jsx)(InviteUserModal_1.InviteUserModal, { accounts: accounts, onSend: init, isOpen: isInvitationModalOpen, close: () => setIsInvitationModalOpen(false) })] }));
}
exports.default = AdminUsers;
